import {Nullish} from 'shared/web';

import {cataloguePlaceholders} from '../constants/cataloguePlaceholders';
import {VehicleMakeModelData} from '../types/VehicleMakeModelParsers';
import {sortByLabel} from './sortByLabel';

/**
 * Makes a value can be set to: the catalogue without its placeholder and without the tenant's own
 * makes, which vehicleMakeParser and useVehicleMake deliberately merge in for pickers that filter
 * rather than write.
 */
export function toSelectableMakeOptions(catalogue: VehicleMakeModelData | Nullish) {
  return (
    sortByLabel(
      (catalogue ?? [])
        .filter((entry) => entry.make !== cataloguePlaceholders.make)
        .map((entry) => ({value: entry.make, label: entry.default_label}))
    ) ?? []
  );
}
